import React, { useState } from "react";



import logoCloud from '../../images/logo/logoCloud.png';
import logo2 from '../../images/logo/logo2.png';
 
import LoginSlider from "./LoginSlider";
 
import "./Login.scss";

const Login = () => {
  return (
    <> 
        <div className="container-fluid p-0"> 
            <div className="login-area">  
                <div className="login-form">
                    <div className="logo-head">
                        <div className="logo-2">
                            <img src={logoCloud} />
                        </div>
                        <div className="h4">Melde dich bei deinem Konto an.</div>
                        <form action="/">
                            <div className="form-group">
                                <label className="emails"><span>*</span> Your Email</label>
                                <input type="text"  />
                            </div>
                            <div className="form-group">
                                <label className="pass"><span>*</span> Passwort</label>
                                <input type="password"  />
                            </div>
                            <div className="form-group">
                                <button type="submit" className="subBtn"><i class="fa-solid fa-unlock"></i> Anmelden</button>
                            </div>
                        </form>
                    </div>
                    <div className="logo-footer">
                        <div className="h6">Du hast noch keinen Account? <a href="#">Starte Hier</a></div>
                        <img src={logo2} />
                    </div>
                </div> 
                <div className="login-slid ">
                    <LoginSlider/>
                </div>
            </div>  
        </div>  
    </>
  );
};

export default Login;
